<!--卡变更日志-->
<template>
  <div  class="app-container">
    <!--查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="120px">
          <el-form-item label="卡号:">
            <el-input v-model="queryParam.userPhone" placeholder=""></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>

    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        max-height="520"
        v-loading="listLoading"
        border>
        <el-table-column prop="userPhone" label="卡号" ></el-table-column>
        <el-table-column prop="oldEndDate" label="原过期日期" ></el-table-column>
        <el-table-column prop="newEndDate" label="现过期日期" ></el-table-column>
        <el-table-column prop="oldCountDes" label="原卡次" ></el-table-column>
        <el-table-column prop="newCountDes" label="现卡次" ></el-table-column>
        <el-table-column prop="oldTotalPay" label="原金额" ></el-table-column>
        <el-table-column prop="newTotalPay" label="现金额" ></el-table-column>
        <el-table-column prop="oldStoreLessonCardName" label="原卡类型" ></el-table-column>
        <el-table-column prop="newStoreLessonCardName" label="现卡类型" ></el-table-column>
        <el-table-column prop="workerName" label="操作人" ></el-table-column>
        <el-table-column prop="createTime" label="操作时间" ></el-table-column>
        <el-table-column prop="typeDes" label="类型" ></el-table-column>
        <el-table-column prop="remark" label="备注" ></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>
<script>

  import {qlChangeCard} from "../../../api/changeCardRecord";
  import commonUtils from "../../../utils/commonUtils";
  import globaldata from "../../../utils/globaldata";
  import {EChangeCardType} from "../../../utils/enumsUtil";

  export default {

    data() {
      return {
        listLoading: true,
        queryParam:{
          userPhone: '',

          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },



        //表单结果
        tableData: [
        ],




      }
    },
    created(){

      globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);

    },
    mounted() {

    },
    methods: {


      getStoreLessonTemplate(data){
        this.storeLessons =data;
        this.flechList();
      },
      flechList(){
        this.listLoading = true;
        let param = {
          userPhone: this.queryParam.userPhone,
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        qlChangeCard(param).then(response =>
        {
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);

        })
      },
      //刷新页面数据
      refreshData(list){

        if (commonUtils.isObjectNull(list)){
          return;
        }

        let tableDataList = [];
        for (let i = 0;i< list.length;++i){

          let oldCountDes =  list[i].oldCount + "/" +list[i].oldGiveCount;
          let newCountDes = list[i].newCount + "/" +list[i].newGiveCount;
          let data = {

            id: list[i].id,
            oldCardId: list[i].oldCardId,
            newCardId: list[i].newCardId,
            userPhone: list[i].userPhone,
            oldEndDate:list[i].oldEndDate,
            newEndDate:list[i].newEndDate,
            createCardDate: list[i].createCardDate,
            oldCount:list[i].oldCount,
            oldGiveCount:list[i].oldGiveCount,
            newCount:list[i].newCount,
            oldCountDes:oldCountDes,
            newCountDes:newCountDes,
            newGiveCount :list[i].newGiveCount,
            oldTotalPay:list[i].oldTotalPay,
            newTotalPay:list[i].newTotalPay,
            oldStoreLessonCardId :list[i].oldStoreLessonCardId,
            newStoreLessonCardId:list[i].newStoreLessonCardId,
            oldStoreLessonCardName :list[i].oldStoreLessonCardName,
            newStoreLessonCardName:list[i].newStoreLessonCardName,
            workerId:list[i].workerId,
            workerName:list[i].workerName,
            createTime:list[i].createTime,
            type:list[i].type,
            typeDes :EChangeCardType(list[i].type),
            remark:list[i].remark,
          };
          tableDataList.push(data);
        }

        this.tableData = tableDataList;
      },
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.flechList();
      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/card/change-card-record/index.vue